import loadable from '@loadable/component';
import * as React from 'react';

import { Preloader } from '../../components/Preloader';

export const MapLoadable = loadable(() => import('./MapContainer'), {
  ssr: false,
  fallback: <Preloader size={32} />,
});
